__turbopack_context__.v({
  "container": "product-specs-module__B5nHZq__container",
  "content": "product-specs-module__B5nHZq__content",
  "overview": "product-specs-module__B5nHZq__overview",
  "root": "product-specs-module__B5nHZq__root",
  "textWrapper": "product-specs-module__B5nHZq__textWrapper",
});
